import { clamp, createCubicBezierEasingFunction } from './MathUtils'
// TODO order of functions got out of hand
// TODO improve performance on resize.. its the progressbar (i think the dom change)
// TODO split in classes like it would be splitted in the DOM (slidercomponent, slideritem, progressbar, progressbarElement etc?) is this
class Slider {
    static INTERACTION_STATES = {
        IDLE: "IDLE",
        DRAGGING: "DRAGGING",
        TRANSITIONING: "TRANSITIONING"
    }

    // TODO extract the animationLoop / transitions into separate class. we need to find a good concept to cathc the repeating parts
    static TRANSITION_CONFIG = {
        easingFunction: createCubicBezierEasingFunction(0.6, 0, 0.4, 1),
        speedPxPerSecond: 500,
        minDurationMs: 300,
        maxDurationMs: 800
    }

    // TODO during transitionTo sync time so they are both finished on the same time
    static PROGRESS_BAR_TRANSITION_CONFIG = {
        easingFunction: createCubicBezierEasingFunction(0.6, 0, 0.4, 1),
        speedPxPerSecond: 300,
        minDurationMs: 300,
        maxDurationMs: 800
    }

    static STABLE_ITEM_WIDTH_CONFIG = {
        maxTimeBetweenResizeEventsBeforeInit: 50,
        maxTimeBeforeInit: 300
    }

    static AUTOPLAY_PROGRESS_TRANSITION_DURATION = 5000

    constructor(sliderComponentElement) {
        this.sliderComponentElement = sliderComponentElement;
        this.initializeStableInstanceProperties()
        this.setInitialState()
    }

    initializeStableInstanceProperties() {
        this.queryStableDomReferences()
        this.setInstanceConfig()
        this.setEventHandlers()
        this.calculateDerivedProperties()
    }

    queryStableDomReferences() {
        this.visibleAreaElement = this.sliderComponentElement.querySelector('.visible-area')
        this.pageWrapperElement = this.sliderComponentElement.querySelector('.page-wrapper')
        this.itemContainerElement = this.sliderComponentElement.querySelector('.item-container')
        this.sourceAnchorElements = this.itemContainerElement.querySelectorAll('a')
        this.sourceImageElements = this.itemContainerElement.querySelectorAll('img')
        this.sourceItemElements = this.itemContainerElement.querySelectorAll(':scope > *')
        this.visibleAreaProgressBarElement = this.sliderComponentElement.querySelector('.visible-area-progress-bar')
        this.progressBarElement = this.sliderComponentElement.querySelector('.slider-progress-bar')
    }

    setInstanceConfig() {
        this.itemGap = Number(this.sliderComponentElement.dataset.itemGap)
        this.showProgressBar = this.sliderComponentElement.dataset.showProgressBar === 'true'
        this.infinite = this.sliderComponentElement.dataset.infinite === 'true'
        this.autoplay = this.sliderComponentElement.dataset.autoplay === 'true'
        this.activeProgressElementUpdatesOnTransitionStart = this.sliderComponentElement.dataset.activeProgressElementUpdatesOnTransitionStart === 'true'
        this.slideOnClick = this.sliderComponentElement.dataset.slideOnClick === 'true'
    }

    setEventHandlers() {
        this.itemContainerPointerEventHandlers = {
            pointerdown: (event) => this.handlePointerDownEvent(event),
            pointermove: (event) => this.handlePointerMoveEvent(event),
            lostpointercapture: (event) => this.handlePointerEndEvent(event),
            contextmenu: (event) => this.handlePointerEndEvent(event),
            click: (event) => this.handleClickEvent(event)
        }
    }

    calculateDerivedProperties() {
        this.sourceItemCount = this.sourceItemElements.length
    }

    setInitialState() {
        this.sliderIsInitialized = false // changes on autonomous behavior
        this.sliderIsActive = false  // changes on active/inactive
        this.resizeAnimationFrameId = null // changes on resize

        this.setInitialWaitingForStableItemWidthState()
        this.setInitialLayoutMeasurementState()
        this.setInitialActiveSliderFunctionalityState()
    }

    setInitialWaitingForStableItemWidthState() {
        this.resizeTimeoutId = null // changes on resize
        this.maxInitTimeoutId = null // changes on autonomous behavior
    }

    // TODO add this.itermAreOverflowing = null?
    setInitialLayoutMeasurementState() {
        this.visibleWidthFromFirstSnapPoint = null
        this.sourceItemWidths = []
        this.widthOfAllSourceItemsAndGaps = null
    }

    setInitialActiveSliderFunctionalityState() {
        this.setInitialRenderedItemsAndGeometryState()
        this.setInitialPositionState()
        this.setInitialProgressBarState()
        this.setInitialInteractionState()
        this.setInitialTransitionState()
        this.setInitialAutoplayState()
    }

    setInitialRenderedItemsAndGeometryState() {
        /* CloneItemsInserted State and derived State of it */
        this.clonedItemsInserted = false // changes on activate&deactivate
        this.renderedItemElements = this.itemContainerElement.querySelectorAll(':scope > *') /* DYNAMIC DOM REFERENCES */ // could also be live collections
        this.renderedItemCount = this.renderedItemElements.length

        /* SnapPoints State and derived State of it */
        this.snapPoints = [] // changes on resize
        this.maxTranslateLeftDistance = null

        /* Progress Elements State */
        this.progressElements = [] // changes on resize
    }

    setInitialPositionState() {
        this.translateLeftDistance = 0 // changes on resize / changes on interaction / changes on autonomous behavior
        this.renderedCurrentIndex = 0 // sometimes this is canonical
        this.exactRenderedCurrentIndex = 0
        this.sourceCurrentIndex = 0
        this.notBoundToTranslateSourceCurrentIndex = 0
    }

    setInitialProgressBarState() {
        this.activeProgressElementIndex = null // changes on activate&deactivate / changes on interaction / changes on autonomous behavior
        this.progressBarTranslateLeftDistance = 0

        this.progressBarTransitionState = { // changes on resize
            currentTransitionEndValue: null,
            animationFrameId: null,
            animationStartTime: null,
            durationMs: null,
            startTranslateDistance: null,
            totalTranslateDistance: null
        }
    }

    setInitialInteractionState() {
        this.interactionState = Slider.INTERACTION_STATES.IDLE // changes on interaction

        this.dragState = { // changes on Interaction
            initialCursorPositionX: null,
            cursorPositionX: null,
            didDrag: false
        }
    }

    setInitialTransitionState() {
        this.transitionState = { // changes on activate&deactivate / changes on interaction / changes on autonomous behavior
            currentTransitionEndValue: null,
            currentTransitionToIndex: null,
            animationFrameId: null,
            animationStartTime: null,
            durationMs: null,
            startTranslateDistance: null,
            totalTranslateDistance: null
        }
    }

    setInitialAutoplayState() {
        this.autoplayState = { // changes on activate&deactivate / changes on interaction / changes on autonomous behavior
            currentIndex: null,
            transitionAnimationFrameId: null,
            transitionAnimationStartTime: null,
            currentInactiveRatio: null
        }
    }


    initializeComponent() {
        // there are things which are one time per instance like this
        this.initCssVariables()
        this.initResizeObserver()
        this.resizeTimeoutId = setTimeout(() => this.initializeSlider(), Slider.STABLE_ITEM_WIDTH_CONFIG.maxTimeBetweenResizeEventsBeforeInit)
        this.maxInitTimeoutId = setTimeout(() => this.initializeSlider(), Slider.STABLE_ITEM_WIDTH_CONFIG.maxTimeBeforeInit)
    }

    initCssVariables() {
        this.setItemGap()
    }

    setItemGap() {
        this.itemContainerElement.style.setProperty('--item-gap', `${this.itemGap}px`);
    }

    initializeSlider() {
        this.clearWaitingForStableItemWithTimers()

        if (this.itemsAreOverflowing()) {
            this.activateSlider()
        }
        this.makeComponentVisible()
        this.sliderIsInitialized = true
    }

    clearWaitingForStableItemWithTimers() {
        clearTimeout(this.resizeTimeoutId)
        clearTimeout(this.maxInitTimeoutId)
        this.resizeTimeoutId = null
        this.maxInitTimeoutId = null
    }

    // TODO should we leave this as function or write it in a separate state variable (i tend to option:b, same as the getters) option a has advantage that its always up to date, disadvantag calculated every read / option b has the advantage that the state is visible in the initState function and only calculated when changing
    // TODO there are hidden calculations here inside
    // TODO so we have measureSlider() and itemsAreOverflowing()
    itemsAreOverflowing() {
        // TODO this method for example is only used inside of this function. so we could make it here inside with const/function or some other pattern / or even a new class
        this.calculateVisibleWidthFromFirstSnapPoint()
        this.calculateSourceItemWidths()

        this.calculateWidthOfAllSourceItemsAndGaps()

        const OVERFLOW_PIXEL_TOLERANCE = 0.1
        return this.widthOfAllSourceItemsAndGaps > this.visibleWidthFromFirstSnapPoint + OVERFLOW_PIXEL_TOLERANCE
    }

    calculateVisibleWidthFromFirstSnapPoint() {
        let paddingBetweenPageWrapperAndVisibleArea = (this.visibleAreaElement.getBoundingClientRect().width - this.pageWrapperElement.getBoundingClientRect().width) / 2
        this.visibleWidthFromFirstSnapPoint = this.visibleAreaElement.getBoundingClientRect().right - this.visibleAreaElement.getBoundingClientRect().left - paddingBetweenPageWrapperAndVisibleArea
    }

    calculateSourceItemWidths() {
        this.sourceItemWidths = []
        this.sourceItemElements.forEach((sourceItemElement) => {
            let sourceItemWidth = sourceItemElement.getBoundingClientRect().width
            this.sourceItemWidths.push(sourceItemWidth)
        })
    }

    calculateWidthOfAllSourceItemsAndGaps() {
        this.widthOfAllSourceItemsAndGaps = 0
        this.sourceItemWidths.forEach((sourceItemWidth) => {
            this.widthOfAllSourceItemsAndGaps += sourceItemWidth
            this.widthOfAllSourceItemsAndGaps += this.itemGap
        })

        this.widthOfAllSourceItemsAndGaps -= this.itemGap
    }

    activateSlider() {
        this.buildCoreSliderDom() // not dependent on state
        this.buildSnapPointDependentParts()
        this.attachDragInteractionAndStartBehavior()
        this.setSliderIsActive(true)
    }

    makeComponentVisible() {
        this.sliderComponentElement.style.opacity = '1'
    }

    buildCoreSliderDom() {
        this.setDraggableFalseOnImageAndAnchorElements() // build DOM / state
        this.insertCloneItemElementsAtBeginningAndEnd()
    }


    //TODO can we somehow enable user-select cleanly too? why is user select working on safari?
    setDraggableFalseOnImageAndAnchorElements() {
        [...this.sourceAnchorElements, ...this.sourceImageElements].forEach((element) => {
            element.draggable = false
        })
    }

    //TODO this clones ids aswell. not good..
    insertCloneItemElementsAtBeginningAndEnd() {
        // TODO do we still need this flag?
        if (this.infinite) {
            const beginningFragment = document.createDocumentFragment()
            const endFragment = document.createDocumentFragment()

            this.sourceItemElements.forEach((sourceItemElement) => {
                beginningFragment.appendChild(sourceItemElement.cloneNode(true))
                endFragment.appendChild(sourceItemElement.cloneNode(true))
            })

            this.itemContainerElement.prepend(beginningFragment)
            this.itemContainerElement.append(endFragment)

            this.clonedItemsInserted = true
            this.updateRenderedValues()
        }
    }

    updateRenderedValues() {
        this.renderedItemElements = this.itemContainerElement.querySelectorAll(':scope > *')
        this.renderedItemCount = this.renderedItemElements.length
    }

    buildSnapPointDependentParts() {
        this.calculateSnapPoints()
        this.buildProgressElementDom()
        this.buildPosition()
    }

    calculateSnapPoints() {
        let widthOfAllItemElementsAndGaps = 0

        this.snapPoints = [0]

        for (let i = 0; i < this.renderedItemCount; i++) {
            let widthOfAllPreviousItemElementsAndGaps = widthOfAllItemElementsAndGaps
            let itemElementWidth = this.sourceItemWidths[i % this.sourceItemCount]
            widthOfAllItemElementsAndGaps += (itemElementWidth + this.itemGap)
            let snapPoint = itemElementWidth + this.itemGap + widthOfAllPreviousItemElementsAndGaps
            this.snapPoints.push(snapPoint)
        }

        let theoreticalSnapPointOfAdditionalItem = this.snapPoints.pop()
        this.calculateMaxTranslateLeftDistance(theoreticalSnapPointOfAdditionalItem)
    }

    calculateMaxTranslateLeftDistance(theoreticalSnapPointOfAdditionalItem) {
        // TODO is this correct? is snappoints correct or do we need possibleSnappoints
        if (this.itemsAreOverflowing()) { // second calculation of the values during resize
            if (this.infinite) {
                this.maxTranslateLeftDistance = this.snapPoints[this.snapPoints.length - 1] // TODO not really?
            } else {
                let rightDistanceOfLastItem = theoreticalSnapPointOfAdditionalItem - this.itemGap
                let minSnapPointForLastItemVisible = rightDistanceOfLastItem - this.visibleWidthFromFirstSnapPoint

                this.maxTranslateLeftDistance = this.snapPoints.find((snapPoint) => {
                    return Math.abs(minSnapPointForLastItemVisible - snapPoint) < 0.5 || snapPoint > minSnapPointForLastItemVisible
                })
            }
        } else {
            this.maxTranslateLeftDistance = 0
        }
    }

    buildProgressElementDom() {
        // everytime
        this.initCurrentlyNeededProgressElements()
        this.initProgressElementListener() // this should be here. maybe also in initCurrentlyNeededProgressElements
    }

    /**
     * currently needed because they can change based on the viewport
     * Everytime they are all created and inserted (they overwrite the old ones and their Event Listeners)
     */
    //TODO update them and their eventlisteners instead of replacing
    initCurrentlyNeededProgressElements() {
        if (this.showProgressBar) {
            let numberOfProgressElements = this.getNumberOfProgressElements()
            this.createProgressElements(numberOfProgressElements)
            this.progressElements = this.progressBarElement.querySelectorAll('.slider-progress-element')
        }
    }

    // TODO this could also be named like getNumberOfSnappoints?
    getNumberOfProgressElements() {
        if (this.infinite) {
            return this.sourceItemCount
        } else {
            return this.snapPoints.indexOf(this.maxTranslateLeftDistance) + 1
        }
    }

    createProgressElements(numberOfProgressElements) {
        let progressElementsHTML = ''
        for (let i = 0; i < numberOfProgressElements; i++) {
            progressElementsHTML += this.getProgressElementHTML()
        }
        this.progressBarElement.innerHTML = progressElementsHTML
    }

    getProgressElementHTML() {
        return `
            <div class="slider-progress-element">
                <div class="slider-progress-element-hover">
                    <div class="slider-progress-element-visible">
                        <div class="slider-progress-element-visible-active">
                        </div>

                        <div class="slider-progress-element-visible-inactive">
                        </div>
                    </div>
                </div>
            </div>
        `
    }

    buildPosition() {
        // everytime
        // TODO is this correct? on resize especially. it would be true if we recalculate translateLeftDistance before
        // TODO maybe move it also outside of this activate function? we will see
        this.translateSliderToExactRenderedCurrentIndex()
    }

    attachDragInteractionAndStartBehavior() {
        // only from inactive to active (if progressElementListeners are not inside)
        this.initItemContainerPointerEventListeners() // attach interaction
        // only from inactive to active
        this.startAutoplay() // then start autonomous behavior
    }

    setActiveProgressElement() {
        if (this.showProgressBar && this.progressElements.length > 0) {

            // 2 modes with activeProgressElementUpdatesOnTransitionStart:
            // either updates based on sourceCurrentIndex or TransitionToIndex
            let activeProgressElementIndex = this.getActiveProgressElementIndex()

            this.progressElements.forEach((progressElement, index) => {
                // make it active
                if (index === activeProgressElementIndex) {

                    // special autoplay cases (there is no autoplay during drag)
                    if (this.autoplay && this.interactionState !== Slider.INTERACTION_STATES.DRAGGING) {

                        // this is so the transitionTo Element is not getting fully active and can start with the 0 active progress
                        if (index === this.transitionState.currentTransitionToIndex % this.sourceItemCount && this.interactionState === Slider.INTERACTION_STATES.TRANSITIONING) {

                            // with this it can start immediatly after it is the activeProgressElement
                            if (!this.activeProgressElementUpdatesOnTransitionStart) {
                                this.startAutoplay()
                            }

                            return
                        }

                        // this is so the current autoplay element is not getting fully active
                        if (index === this.autoplayState.currentIndex) {

                            // (also during resize) because of wrong order in requestAnimationFrame Callbacks
                            if (this.autoplayState.currentInactiveRatio != null) {
                                this.setProgressElementInactiveRatio(progressElement, this.autoplayState.currentInactiveRatio)
                            }

                            return
                        }
                    }

                    // make it active
                    this.setProgressElementInactiveRatio(progressElement, 0)
                } else {
                    // make it inactive
                    this.setProgressElementInactiveRatio(progressElement, 1.1)
                }
            })
        }
    }

    // TODO we could call this once at the right time and save it?
    getActiveProgressElementIndex() {
        let activeProgressElementIndex
        if (this.activeProgressElementUpdatesOnTransitionStart === true && this.interactionState === Slider.INTERACTION_STATES.TRANSITIONING) {
            activeProgressElementIndex = this.transitionState.currentTransitionToIndex % this.sourceItemCount
        } else {
            activeProgressElementIndex = this.sourceCurrentIndex
        }

        if (this.activeProgressElementIndex !== activeProgressElementIndex) {
            this.activeProgressElementIndex = activeProgressElementIndex
            // TODO should we really call it like this. based on if there is a new index
            this.checkIfActiveProgressElementIsVisible()
        }
        return activeProgressElementIndex
    }

    // TODO there was the idea of a recursive slider? so we can drag the progressbar like a slideshow and control the translate from outside
    checkIfActiveProgressElementIsVisible() {
        if (!this.showProgressBar || this.progressElements.length === 0) {
            return
        }
        const visibleAreaProgressBarElementBoundingRect = this.visibleAreaProgressBarElement.getBoundingClientRect()
        const visibleAreaProgressBarElementWidth = visibleAreaProgressBarElementBoundingRect.width
        const visibleAreaProgressBarElementLeft = visibleAreaProgressBarElementBoundingRect.left
        const visibleAreaProgressBarElementRight = visibleAreaProgressBarElementBoundingRect.right

        const activeProgressElement = this.progressElements[this.activeProgressElementIndex]
        const activeProgressElementBoundingRect = activeProgressElement.getBoundingClientRect()

        // get remainingTranslate
        const progressBarTranslateAfterCurrentTransitionIsCompleted =
            this.progressBarTransitionState.currentTransitionEndValue != null
                ? this.progressBarTransitionState.currentTransitionEndValue
                : this.progressBarTranslateLeftDistance
        const remainingTranslate = progressBarTranslateAfterCurrentTransitionIsCompleted - this.progressBarTranslateLeftDistance

        // translateX(-x) moves the element left as x increases
        const activeProgressElementLeftAfterCurrentTransitionIsCompleted = activeProgressElementBoundingRect.left - remainingTranslate
        const activeProgressElementRightAfterCurrentTransitionIsCompleted = activeProgressElementBoundingRect.right - remainingTranslate

        // middle calculation
        // TODO make to different thresholds/modes one where it starts moving when its outside and one for how much it should move in the middle
        const threshold = (visibleAreaProgressBarElementWidth / 2) - (this.progressElements[0].getBoundingClientRect().width / 2)
        // TODO check it out. looks good with for example value of 100
        const thresholdSmall = (visibleAreaProgressBarElementWidth / 2) - (this.progressElements[0].getBoundingClientRect().width / 2)

        const isProgressElementRightVisible = visibleAreaProgressBarElementRight >= activeProgressElementRightAfterCurrentTransitionIsCompleted + thresholdSmall
        const isProgressElementLeftVisible = visibleAreaProgressBarElementLeft <= activeProgressElementLeftAfterCurrentTransitionIsCompleted - thresholdSmall

        if (!isProgressElementRightVisible) {
            const diffBetweenProgressElementRightAndVisibleAreaProgressBarElementRight = activeProgressElementRightAfterCurrentTransitionIsCompleted - visibleAreaProgressBarElementRight
            const newTranslateLeftDistance = diffBetweenProgressElementRightAndVisibleAreaProgressBarElementRight + progressBarTranslateAfterCurrentTransitionIsCompleted + threshold
            this.progressBarElementTransitionTo(newTranslateLeftDistance)
        }

        if (!isProgressElementLeftVisible) {
            const distanceToMoveRight = visibleAreaProgressBarElementLeft + threshold - activeProgressElementLeftAfterCurrentTransitionIsCompleted
            const newTranslateLeftDistance = progressBarTranslateAfterCurrentTransitionIsCompleted - distanceToMoveRight
            this.progressBarElementTransitionTo(newTranslateLeftDistance)
        }

        const progressBarTranslateAfterVisibilityAdjustment =
            this.progressBarTransitionState.currentTransitionEndValue != null
                ? this.progressBarTransitionState.currentTransitionEndValue
                : this.progressBarTranslateLeftDistance
        const remainingTranslateAfterVisibilityAdjustment =
            progressBarTranslateAfterVisibilityAdjustment - this.progressBarTranslateLeftDistance

        const firstProgressElementLeft =
            this.progressElements[0].getBoundingClientRect().left - remainingTranslateAfterVisibilityAdjustment
        const lastProgressElementRight =
            this.progressElements[this.progressElements.length - 1].getBoundingClientRect().right - remainingTranslateAfterVisibilityAdjustment

        const isOverflowingOnTheLeft = firstProgressElementLeft < visibleAreaProgressBarElementLeft
        const isOverflowingOnTheRight = lastProgressElementRight > visibleAreaProgressBarElementRight

        this.visibleAreaProgressBarElement.classList.toggle('has-overflow-left', isOverflowingOnTheLeft)
        this.visibleAreaProgressBarElement.classList.toggle('has-overflow-right', isOverflowingOnTheRight)
    }

    progressBarElementTransitionTo(transitionPoint) {
        // TODO clamp here makes more sense but then remove it in the translateLeft function. we only need this one time
        const maxTranslateLeftDistance = this.progressBarElement.getBoundingClientRect().width - this.visibleAreaProgressBarElement.getBoundingClientRect().width
        transitionPoint = clamp(transitionPoint, 0, maxTranslateLeftDistance)
        if (this.progressBarTransitionState.animationFrameId != null) {
            this.progressBarTransitionState.currentTransitionEndValue = transitionPoint
            return
        }

        this.progressBarTransitionState = this.getInitialProgressBarTransitionState(transitionPoint)
        this.progressBarTransitionState.animationFrameId = requestAnimationFrame((currentTime) => {
            this.progressBarElementTransitionToAnimationLoop(currentTime)
        })
    }

    getInitialProgressBarTransitionState(transitionPoint) {
        const startTranslateDistance = this.progressBarTranslateLeftDistance
        const totalTranslateDistance = transitionPoint - startTranslateDistance
        const absoluteDistance = Math.abs(totalTranslateDistance)
        const unclampedDurationMs = (
            absoluteDistance / Slider.PROGRESS_BAR_TRANSITION_CONFIG.speedPxPerSecond
        ) * 1000

        return {
            currentTransitionEndValue: transitionPoint,
            animationFrameId: null,
            animationStartTime: null,
            durationMs: clamp(
                unclampedDurationMs,
                Slider.PROGRESS_BAR_TRANSITION_CONFIG.minDurationMs,
                Slider.PROGRESS_BAR_TRANSITION_CONFIG.maxDurationMs
            ),
            startTranslateDistance,
            totalTranslateDistance
        }
    }

    progressBarElementTransitionToAnimationLoop(currentTime) {
        if (this.progressBarTransitionState.animationStartTime == null) {
            this.progressBarTransitionState.animationStartTime = currentTime
        }

        const transitionPoint = this.progressBarTransitionState.currentTransitionEndValue
        const startTranslateDistance = this.progressBarTransitionState.startTranslateDistance
        const totalTranslateDistance = transitionPoint - startTranslateDistance
        const absoluteDistance = Math.abs(totalTranslateDistance)
        const unclampedDurationMs = (
            absoluteDistance / Slider.PROGRESS_BAR_TRANSITION_CONFIG.speedPxPerSecond
        ) * 1000
        const durationMs = clamp(
            unclampedDurationMs,
            Slider.PROGRESS_BAR_TRANSITION_CONFIG.minDurationMs,
            Slider.PROGRESS_BAR_TRANSITION_CONFIG.maxDurationMs
        )

        const elapsedTime = currentTime - this.progressBarTransitionState.animationStartTime
        const progress = durationMs === 0 ? 1 : Math.min(elapsedTime / durationMs, 1)
        const easedProgress = Slider.PROGRESS_BAR_TRANSITION_CONFIG.easingFunction(progress)
        const newTranslateLeftDistance =
            startTranslateDistance +
            (totalTranslateDistance * easedProgress)

        this.translateProgressBarElementToLeft(newTranslateLeftDistance)

        if (progress < 1) {
            this.progressBarTransitionState.animationFrameId = requestAnimationFrame((nextCurrentTime) => {
                this.progressBarElementTransitionToAnimationLoop(nextCurrentTime)
            })
            return
        }

        this.handleProgressBarTransitionEnd()
    }

    handleProgressBarTransitionEnd() {
        this.translateProgressBarElementToLeft(this.progressBarTransitionState.currentTransitionEndValue)
        this.resetProgressBarTransitionState()
    }

    cancelProgressBarTransition() {
        if (this.progressBarTransitionState.animationFrameId != null) {
            cancelAnimationFrame(this.progressBarTransitionState.animationFrameId)
        }
        this.resetProgressBarTransitionState()
    }

    resetProgressBarTransitionState() {
        this.progressBarTransitionState = {
            currentTransitionEndValue: null,
            animationFrameId: null,
            animationStartTime: null,
            durationMs: null,
            startTranslateDistance: null,
            totalTranslateDistance: null
        }
    }

    // TODO there are some pixel artifacts on the right of the last progress element
    translateProgressBarElementToLeft(newTranslateLeftDistance) {
        const maxTranslateLeftDistance = this.progressBarElement.getBoundingClientRect().width - this.visibleAreaProgressBarElement.getBoundingClientRect().width
        this.progressBarTranslateLeftDistance = clamp(newTranslateLeftDistance, 0, maxTranslateLeftDistance)
        this.progressBarElement.style.transform = `translateX(-${this.progressBarTranslateLeftDistance}px)`
    }


    // better naming? would also bette be setProgressElementActiveRation
    setProgressElementInactiveRatio(progressElement, inactiveRatio) {
        let activeElement = progressElement.querySelector('.slider-progress-element-visible-active')
        activeElement.style.transform = `translate(-${inactiveRatio * 100}%, -50%)`
    }

    startAutoplay() {
        if (!this.autoplay) {
            return
        }

        // TODO is this correct?
        if (this.interactionState === Slider.INTERACTION_STATES.DRAGGING) {
            return
        }

        if (this.autoplayState.transitionAnimationFrameId != null) {
            return
        }

        //this.autoplayState.currentIndex = this.sourceCurrentIndex
        // TODO verify if this is correct (it was = this.sourceCurrentIndex before)
        this.autoplayState.currentIndex = this.getActiveProgressElementIndex()
        this.autoplayState.transitionAnimationFrameId = requestAnimationFrame((currentTime) => {
            this.autoplayTransitionAnimationLoop(currentTime)
        })
    }

    autoplayTransitionAnimationLoop(currentTime) {
        // set startTime of Animation
        if (this.autoplayState.transitionAnimationStartTime == null) {
            this.autoplayState.transitionAnimationStartTime = currentTime
        }

        // calculate elapsed Time
        const elapsedTime = currentTime - this.autoplayState.transitionAnimationStartTime
        // 3s / 5s for example (maximal 1)
        const progress = Math.min(elapsedTime / Slider.AUTOPLAY_PROGRESS_TRANSITION_DURATION, 1)

        this.autoplayState.currentInactiveRatio = 1 - progress

        // show progress on activeProgressElement
        if (this.showProgressBar) {
            // 2 Status von active: (running oder nicht)
            // 2 Modis bei TRANSITIONING (Entweder wird active element über sourceCurrentIndex (based on translateX) oder über currentTransitionToIndex definiert)
            // Die active running animation wird dementsprechend zu unterschiedlichen Zeitpunkten gestartet
            let activeProgressElementIndex = this.getActiveProgressElementIndex()
            this.setProgressElementInactiveRatio(this.progressElements[activeProgressElementIndex], this.autoplayState.currentInactiveRatio)
        }

        // rerun animation loop
        if (progress < 1) {
            this.autoplayState.transitionAnimationFrameId = requestAnimationFrame((currentTime) => this.autoplayTransitionAnimationLoop(currentTime))
            return
        }
        // stop animation loop
        this.handleAutoplayTransitionEnd()
    }

    handleAutoplayTransitionEnd() {
        this.stopAutoplay()
        this.slideToNextItem()
    }

    slideToNextItem() {
        // save this or getter?
        const indexPlusOne = (this.sourceCurrentIndex + 1) % this.getNumberOfProgressElements()
        this.slideToSourceItemIndex(indexPlusOne)
        // this.transitionTo(this.getSnapPointFromIndex(indexPlusOne))
    }

    slideToNextItemWithNotBoundToTranslateSourceCurrentIndex() {
        // save this or getter?
        const indexPlusOne = (this.notBoundToTranslateSourceCurrentIndex + 1) % this.getNumberOfProgressElements()
        this.notBoundToTranslateSourceCurrentIndex = indexPlusOne
        // TODO prevent slide back to first when last element is selected / also should it slide right or left when going back to the first
        this.slideToSourceItemIndex(indexPlusOne)
        // this.transitionTo(this.getSnapPointFromIndex(indexPlusOne))
    }

    resetAutoplayTransitionState() {
        this.autoplayState = {
            currentIndex: this.autoplayState.currentIndex,
            transitionAnimationFrameId: null,
            transitionAnimationStartTime: null,
            // TODO null or last value? if lastValue it should not go into state?
            currentInactiveRatio: this.autoplayState.currentInactiveRatio
        }
    }

    translateSliderToExactRenderedCurrentIndex() {
        // TODO maybe here also translateToEquivalentPoint
        // TODO we could save a percentage index like 1.2343 which would mean we are 23.43% right from index 2
        // TODO for TRANSITIONING state i want to translate to the equivalent floatedSourceIndex (this never makes a jump) and from there i want the transition to finish to the updated end value with the remaining time
        if (this.interactionState !== Slider.INTERACTION_STATES.TRANSITIONING) { // i think we dont need that but then need to change the updateMethod
            const leftIndex = Math.floor(this.exactRenderedCurrentIndex)
            // not needed because of clamp distance?
            const rightIndex = Math.min(leftIndex + 1, this.snapPoints.length - 1)
            const percentagePart = this.exactRenderedCurrentIndex - leftIndex

            const leftSnapPoint = this.snapPoints[leftIndex]
            const rightSnapPoint = this.snapPoints[rightIndex]
            const distanceBetweenSnapPoints = rightSnapPoint - leftSnapPoint

            const translateLeftDistance = leftSnapPoint + (distanceBetweenSnapPoints * percentagePart)
            this.translateItemContainerElementToLeftAndUpdateDependentState(translateLeftDistance)
        }
    }

    initItemContainerPointerEventListeners() {
        this.itemContainerElement.addEventListener('pointerdown', this.itemContainerPointerEventHandlers.pointerdown)
        this.itemContainerElement.addEventListener('pointermove', this.itemContainerPointerEventHandlers.pointermove)
        // we only need this because pointerup and pointercancel are triggering lostpointercapture
        this.itemContainerElement.addEventListener('lostpointercapture', this.itemContainerPointerEventHandlers.lostpointercapture)
        this.itemContainerElement.addEventListener('contextmenu', this.itemContainerPointerEventHandlers.contextmenu)
        this.itemContainerElement.addEventListener('click', this.itemContainerPointerEventHandlers.click, {capture: true})
    }

    handlePointerDownEvent(event) {
        if (this.interactionState === Slider.INTERACTION_STATES.TRANSITIONING) {
            this.cancelTransition()
        }
        // just a defensive fallback if event.target is not Element
        const pointerCaptureElement = event.target instanceof Element
            ? event.target
            : this.itemContainerElement
        pointerCaptureElement.setPointerCapture(event.pointerId)

        this.changeInteractionStateToDraggingAndStopAutoplay()
        this.dragState.initialCursorPositionX = event.clientX
        this.dragState.cursorPositionX = event.clientX
        this.dragState.didDrag = false
    }

    changeInteractionStateToDraggingAndStopAutoplay() {
        this.interactionState = Slider.INTERACTION_STATES.DRAGGING
        // same sub/not pattern -> other option would be to work with signals
        this.stopAutoplay()
    }

    stopAutoplay() {
        if (this.autoplay) {
            if (this.autoplayState.transitionAnimationFrameId != null) {
                cancelAnimationFrame(this.autoplayState.transitionAnimationFrameId)
            }
            this.resetAutoplayTransitionState()
        }
    }

    cancelTransition() {
        if (this.transitionState.animationFrameId != null) {
            cancelAnimationFrame(this.transitionState.animationFrameId)
        }
        this.resetTransitionState()
    }

    handlePointerMoveEvent(event) {
        if (this.interactionState === Slider.INTERACTION_STATES.DRAGGING) {
            let dragDistanceX = this.dragState.cursorPositionX - event.clientX
            this.dragState.cursorPositionX = event.clientX
            let alreadyDraggedDistance = Math.abs(this.dragState.cursorPositionX - this.dragState.initialCursorPositionX)
            const threshold = 5
            if (alreadyDraggedDistance > threshold && !this.dragState.didDrag) {
                this.dragState.didDrag = true
            }

            let newTranslateLeftDistance = this.translateLeftDistance + dragDistanceX

            this.translateItemContainerElementToLeftAndUpdateDependentState(newTranslateLeftDistance)
        }
    }

    // TODO separate this?
    /**
     * We have a translate which translates to exactRenderedCurrentIndex (this is needed for init and resize)
     * we have a translate on drag
     * we have a translate for infinite-mode to translate back to middle Index
     * we have a translate to nearestSnapPoint if we are visually already on snapPoint but not exactly from the value after drag
     * we have a translate in our transitionToAnimationLoop
     * we have a translate in our transitionEnd
     * we have a translate in deactivate
     * each of these Translates updates currentIndex and this triggers setActiveProgressElement because this is based on sourceCurrentIndex or TransitionToIndex
     */
    translateItemContainerElementToLeftAndUpdateDependentState(newTranslateLeftDistance) {
        this.translateLeftDistance = this.clampDistance(newTranslateLeftDistance)
        this.itemContainerElement.style.transform = `translateX(-${this.translateLeftDistance}px)`

        this.updateRenderedCurrentIndex()
        this.updateExactRenderedCurrentIndex()
        if (this.clonedItemsInserted) {
            // TODO dangerous infinite loop
            this.translateToEquivalentMiddleIndexIfExceeded()
        }
        this.updateSourceCurrentIndex()
        // TODO here we could calculate percentageSourceIndex
        // TODO maybe we only need one
        this.setActiveProgressElement()
    }

    clampDistance(distance) {
        return clamp(distance, this.snapPoints[0], this.maxTranslateLeftDistance)
    }

    updateRenderedCurrentIndex() {
        let nearestSnapPoint = this.findNearestSnapPoint()
        this.renderedCurrentIndex = this.snapPoints.indexOf(nearestSnapPoint)
    }

    updateExactRenderedCurrentIndex() {
        let snapPointLeftFromActualTranslateLeftDistance = this.snapPoints[0]
        for (const snapPoint of this.snapPoints) {
            if (snapPoint <= this.translateLeftDistance) {
                snapPointLeftFromActualTranslateLeftDistance = snapPoint
            } else {
                break
            }
        }
        let indexOfSnapPointLeftFromActualTranslateLeftDistance = this.snapPoints.indexOf(snapPointLeftFromActualTranslateLeftDistance)
        let indexOfSnapPointRightFromActualTranslateLeftDistance = this.snapPoints.length - 1
        if (indexOfSnapPointLeftFromActualTranslateLeftDistance < this.snapPoints.length - 1) {
            indexOfSnapPointRightFromActualTranslateLeftDistance = indexOfSnapPointLeftFromActualTranslateLeftDistance + 1
        }
        let snapPointRightFromActualTranslateLeftDistance = this.snapPoints[indexOfSnapPointRightFromActualTranslateLeftDistance]

        let diffBetweenLeftAndRightSnapPoint = snapPointRightFromActualTranslateLeftDistance - snapPointLeftFromActualTranslateLeftDistance
        let diffBetweenLeftAndTranslateLeftDistance = this.translateLeftDistance - snapPointLeftFromActualTranslateLeftDistance

        let percentagePart
        if (diffBetweenLeftAndRightSnapPoint === 0) {
            percentagePart = 0
        } else {
            percentagePart = diffBetweenLeftAndTranslateLeftDistance / diffBetweenLeftAndRightSnapPoint
        }
        this.exactRenderedCurrentIndex = indexOfSnapPointLeftFromActualTranslateLeftDistance + percentagePart
    }

    translateToEquivalentMiddleIndexIfExceeded() {
        if (this.renderedCurrentIndex < this.sourceItemCount) {
            let equivalentMiddleIndex = this.translateLeftDistance + this.widthOfAllSourceItemsAndGaps + this.itemGap
            this.translateItemContainerElementToLeftAndUpdateDependentState(equivalentMiddleIndex)
        } else if (this.renderedCurrentIndex >= 2 * this.sourceItemCount) {
            let equivalentMiddleIndex = this.translateLeftDistance - this.widthOfAllSourceItemsAndGaps - this.itemGap
            this.translateItemContainerElementToLeftAndUpdateDependentState(equivalentMiddleIndex)
        }
    }

    updateSourceCurrentIndex() {
        const newSourceCurrentIndex = this.renderedCurrentIndex % this.sourceItemCount
        if (newSourceCurrentIndex !== this.sourceCurrentIndex) {
            this.sourceCurrentIndex = newSourceCurrentIndex
            this.notBoundToTranslateSourceCurrentIndex = this.sourceCurrentIndex
        }
    }

    handlePointerEndEvent(event) {
        if (this.interactionState !== Slider.INTERACTION_STATES.DRAGGING) {
            return;
        }

        this.dragState.cursorPositionX = null

        const nearestSnapPoint = this.findNearestSnapPoint()
        const SNAP_POINT_PIXEL_TOLERANCE = 0.5
        const isAlreadyOnSnapPoint = Math.abs(nearestSnapPoint - this.translateLeftDistance) < SNAP_POINT_PIXEL_TOLERANCE

        if (isAlreadyOnSnapPoint) {
            this.translateItemContainerElementToLeftAndUpdateDependentState(nearestSnapPoint)
            this.changeInteractionStateToIdleAndStartAutoplay()
            return
        }

        this.transitionTo(nearestSnapPoint)
    }

    findNearestSnapPoint() {
        let nearestSnapPoint = this.snapPoints[0]

        this.snapPoints.forEach((snapPoint) => {
            const nearestDistance = Math.abs(nearestSnapPoint - this.translateLeftDistance)
            const snapPointDistance = Math.abs(snapPoint - this.translateLeftDistance)

            if (snapPointDistance < nearestDistance) {
                nearestSnapPoint = snapPoint
            }
        })

        return nearestSnapPoint
    }

    // TODO here we start autoplay again after transition completed. so maybe these two are not that tightly coupled how it is implemented now
    changeInteractionStateToIdleAndStartAutoplay() {
        this.interactionState = Slider.INTERACTION_STATES.IDLE
        // TODO maybe introduce subscribe/notify to interactionStateChange, maybe also generic changeInteractionState(state) method and afterInteractionStateChange(prev, current)
        this.startAutoplay()
    }

    // TODO transitionItemContainerToTranslateLeftValue?
    // TODO we could have a general transitionTo or Animate class
    transitionTo(transitionPoint) {
        this.changeInteractionStateToTransitioning()
        this.transitionState = this.getInitialTransitionState(transitionPoint)
        this.transitionState.animationFrameId = requestAnimationFrame((currentTime) => {
            this.transitionToAnimationLoop(currentTime)
        })

        if (this.activeProgressElementUpdatesOnTransitionStart === true) {
            this.startAutoplay()
        }
    }

    // TODO maybe generic method changeInteractionState(state)) changeInteractionStateToTransitioningAndStopAutoplay?
    changeInteractionStateToTransitioning() {
        this.interactionState = Slider.INTERACTION_STATES.TRANSITIONING
        this.stopAutoplay()
    }

    getInitialTransitionState(transitionPoint) {
        const startTranslateDistance = this.translateLeftDistance
        const totalTranslateDistance = transitionPoint - startTranslateDistance
        const absoluteDistance = Math.abs(totalTranslateDistance)
        const unclampedDurationMs = (
            absoluteDistance / Slider.TRANSITION_CONFIG.speedPxPerSecond
        ) * 1000

        return {
            currentTransitionEndValue: transitionPoint,
            currentTransitionToIndex: this.snapPoints.indexOf(transitionPoint),
            animationFrameId: null,
            animationStartTime: null,
            durationMs: clamp(
                unclampedDurationMs,
                Slider.TRANSITION_CONFIG.minDurationMs,
                Slider.TRANSITION_CONFIG.maxDurationMs
            ),
            startTranslateDistance,
            totalTranslateDistance
        }
    }

    transitionToAnimationLoop(currentTime) {
        if (this.transitionState.animationStartTime == null) {
            this.transitionState.animationStartTime = currentTime
        }

        const elapsedTime = currentTime - this.transitionState.animationStartTime
        const progress = Math.min(elapsedTime / this.transitionState.durationMs, 1)
        const easedProgress = Slider.TRANSITION_CONFIG.easingFunction(progress)
        const newTranslateLeftDistance =
            this.transitionState.startTranslateDistance +
            (this.transitionState.totalTranslateDistance * easedProgress)

        this.translateItemContainerElementToLeftAndUpdateDependentState(newTranslateLeftDistance)

        if (progress < 1) {
            this.transitionState.animationFrameId = requestAnimationFrame((nextCurrentTime) => {
                this.transitionToAnimationLoop(nextCurrentTime)
            })
            return
        }

        this.handleTransitionEnd()
    }

    handleTransitionEnd() {
        // TODO is this needed? claude says yes becuase of floating point
        this.translateItemContainerElementToLeftAndUpdateDependentState(this.transitionState.currentTransitionEndValue)
        this.resetTransitionState()
        this.changeInteractionStateToIdleAndStartAutoplay()
    }

    resetTransitionState() {
        this.transitionState = {
            currentTransitionEndValue: null,
            currentTransitionToIndex: null,
            animationFrameId: null,
            animationStartTime: null,
            durationMs: null,
            startTranslateDistance: null,
            totalTranslateDistance: null
        }
    }

    handleClickEvent(event) {
        const clickWasNotSuppressed = this.suppressClickIfItWasADrag(event)
        if (this.slideOnClick && clickWasNotSuppressed) {
            //TODO also make difference (if its on a link click link else..)
            this.slideToNextItemWithNotBoundToTranslateSourceCurrentIndex()
        }
    }

    suppressClickIfItWasADrag(event) {
        if (this.dragState.didDrag) {
            event.preventDefault()
            event.stopPropagation()
            this.dragState.didDrag = false
            return false
        } else {
            return true
        }
    }

    // TODO we can move this into initCurrentlyNeededProgressElements?
    initProgressElementListener() {
        this.progressElements.forEach((progressElement, index) => {
            progressElement.addEventListener('click', (event) => this.handleProgressElementClick(event, index))
        })
    }

    handleProgressElementClick(event, index) {
        this.slideToSourceItemIndex(index)
    }

    slideToSourceItemIndex(index) {
        if (this.interactionState === Slider.INTERACTION_STATES.TRANSITIONING) {
            // if we are already transitioning to the clicked element we can return
            if (this.transitionState.currentTransitionEndValue === this.getSnapPointFromIndex(index)) {
                return
            } else {
                this.cancelTransition()
            }
        }
        // TODO if we are already on this index return (or start autoplay again?) maybe also hardening (check if distance == 0) in transitionTo
        this.transitionTo(this.getSnapPointFromIndex(index))
    }

    getSnapPointFromIndex(index) {
        if (this.infinite) {
            index += this.sourceItemCount
        }
        return this.snapPoints[index]
    }

    setSliderIsActive(sliderIsActive) {
        this.sliderIsActive = sliderIsActive
        this.sliderComponentElement.classList.toggle('active', sliderIsActive)
    }

    initResizeObserver() {
        this.resizeObserver = new ResizeObserver(() => this.handleResizeObserverChange())

        // TODO max observed items?
        this.resizeObserver.observe(this.visibleAreaElement)
        this.sourceItemElements.forEach((sourceItemElement) => {
            this.resizeObserver.observe(sourceItemElement)
        })
    }

    handleResizeObserverChange() {
        if (this.resizeAnimationFrameId != null) {
            return
        }

        // TODO implement own requestAnimationFrame so of all requestAnimationFrame callbacks the resize always runs first
        this.resizeAnimationFrameId = requestAnimationFrame(() => {
            this.resizeAnimationFrameId = null
            this.handleResizeEvent()
        })
    }

    // TODO there are still some light jumps when resizing. not smooth enough..
    handleResizeEvent() {
        if (!this.sliderIsInitialized) {
            this.rescheduleInitializing()
        } else {
            this.updateSliderAfterResize()
        }
    }

    rescheduleInitializing() {
        clearTimeout(this.resizeTimeoutId)
        this.resizeTimeoutId = setTimeout(() => this.initializeSlider(), Slider.STABLE_ITEM_WIDTH_CONFIG.maxTimeBetweenResizeEventsBeforeInit)
    }

    updateSliderAfterResize() {
        if (this.itemsAreOverflowing()) {
            if (!this.sliderIsActive) {
                this.activateSlider()
            } else {
                this.updateActiveSliderAfterResize()
            }
        } else {
            // TODO check which state to reset?
            // TODO if deactivated and activated again should last activate state be restored?
            if (this.sliderIsActive) {
                this.deactivateSlider()
            }
        }
    }

    updateActiveSliderAfterResize() {
        this.buildSnapPointDependentParts()
        if (this.interactionState === Slider.INTERACTION_STATES.TRANSITIONING) {
            this.updateTransitionState()
        }
        // TODO what we have to do? is this already correct?
        this.checkIfActiveProgressElementIsVisible()

        // this is because of the wrong order of the requestAnimationFrameCallbacks
        // if (this.autoplay)
        this.autoplayState.currentIndex = this.getActiveProgressElementIndex()
    }

    deactivateSlider() {
        this.removeDraggableFalseOnImageAndAnchorElements()
        this.removeCloneItemElementsAtBeginningAndEnd()
        this.calculateSnapPoints()
        // reset snapPoints and maxTrasnlateLeftDistance
        this.removeProgressElements()
        // reset positionValue and all values from translateSliderTo
        this.translateItemContainerElementToLeftAndUpdateDependentState(0)
        this.removeItemContainerPointerEventListeners()
        this.stopAutoplay()
        this.cancelTransition()
        this.cancelProgressBarTransition()
        this.translateProgressBarElementToLeft(0)
        this.interactionState = Slider.INTERACTION_STATES.IDLE
        this.setSliderIsActive(false)
    }

    // TODO what if an element originally had draggable false? its not restoring the initial state of this
    removeDraggableFalseOnImageAndAnchorElements() {
        [...this.sourceAnchorElements, ...this.sourceImageElements].forEach((element) => {
            element.draggable = null
        })
    }

    removeCloneItemElementsAtBeginningAndEnd() {
        if (this.infinite) { // TODO here or in the caller... still not sure. also not sure if we should check for cloneItemsInserted.
            this.renderedItemElements.forEach((renderedItemElement, index) => {
                const isBeginningClone = index < this.sourceItemCount
                const isEndingClone = index >= 2 * this.sourceItemCount

                if (isBeginningClone || isEndingClone) {
                    renderedItemElement.remove()
                }
            })

            this.clonedItemsInserted = false
            this.updateRenderedValues()
        }
    }

    removeProgressElements() {
        this.progressElements.forEach((progressElement) => {
            progressElement.remove()
        })
        this.progressElements = []
    }

    removeItemContainerPointerEventListeners() {
        this.itemContainerElement.removeEventListener('pointerdown', this.itemContainerPointerEventHandlers.pointerdown)
        this.itemContainerElement.removeEventListener('pointermove', this.itemContainerPointerEventHandlers.pointermove)
        this.itemContainerElement.removeEventListener('lostpointercapture', this.itemContainerPointerEventHandlers.lostpointercapture)
        this.itemContainerElement.removeEventListener('contextmenu', this.itemContainerPointerEventHandlers.contextmenu)
        this.itemContainerElement.removeEventListener('click', this.itemContainerPointerEventHandlers.click, { capture: true })
    }

    updateTransitionState() {
        const newTransitionToIndex = this.transitionState.currentTransitionToIndex % this.getNumberOfProgressElements()
        const newTransitionToEndValue = this.getSnapPointFromIndex(newTransitionToIndex)
        const newTotalTranslateDistance = newTransitionToEndValue - this.transitionState.startTranslateDistance
        this.transitionState.currentTransitionToIndex = newTransitionToIndex
        this.transitionState.currentTransitionEndValue = newTransitionToEndValue
        this.transitionState.totalTranslateDistance = newTotalTranslateDistance
    }

    // TODO make this
    /*updateTransitionState() {
        const newTransitionToIndex = this.transitionState.currentTransitionToIndex % this.getNumberOfProgressElements()
        const newTransitionToEndValue = this.getSnapPointFromIndex(newTransitionToIndex)

        const currentTime = performance.now()
        const elapsedTime = currentTime - this.transitionState.animationStartTime
        const progress = Math.min(elapsedTime / this.transitionState.durationMs, 1)
        const easedProgress = Slider.TRANSITION_CONFIG.easingFunction(progress)

        const newStartTranslateDistance = (this.translateLeftDistance - newTransitionToEndValue * easedProgress) / (1 - easedProgress)

        this.transitionState.currentTransitionToIndex = newTransitionToIndex
        this.transitionState.currentTransitionEndValue = newTransitionToEndValue
        this.transitionState.startTranslateDistance = newStartTranslateDistance
        this.transitionState.totalTranslateDistance = newTransitionToEndValue - newStartTranslateDistance
    }*/
}

export default function init() {
    const sliderComponentElements = document.querySelectorAll('.slider-component');

    sliderComponentElements.forEach(sliderComponentElement => {
        // TODO move config here (data attributes) and initialize Slider with the arguments) like we have in the cardStacker?
        const sliderComponent = new Slider(sliderComponentElement);
        sliderComponent.initializeComponent()
    });
}
